import React from 'react';
import GemStarIcon from './GemStarIcon';

type Props = {
  positive?: boolean;
  emoji?: string | null;
  size?: number;
  className?: string;
};

/** 포인트 타입 아이콘 — 이모지가 있으면 이모지, 없으면 기본 별 */
const PointTypeIcon: React.FC<Props> = ({ positive = true, emoji, size = 16, className }) => {
  const mark = typeof emoji === 'string' ? emoji.trim() : '';
  if (mark) {
    return (
      <span
        className={className ? `cp-pin-type-emoji ${className}` : 'cp-pin-type-emoji'}
        style={{ fontSize: Math.max(12, Math.round(size * 0.92)), lineHeight: 1 }}
        aria-hidden
      >
        {mark}
      </span>
    );
  }
  return <GemStarIcon positive={positive} size={size} className={className} />;
};

export default PointTypeIcon;
